import styled from 'styled-components'

import { colors } from 'app/theme/colors'

const shadow = '10px 10px 32px -8px rgb(0 0 0 / 20%)'

// Same wrapper geometry as MembershipBlock so the row of cards lines up
// evenly — 264px wide, 226px min-height.
export const Wrapper = styled.div`
  width: ${(props) => props.width || '264'}px;
  min-height: 226px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 16px;
  transition: all 0.5s ease;
  box-shadow: ${shadow};
  background: ${colors.white};

  &:hover {
    box-shadow: unset;
  }
`

export const CardTitle = styled.div`
  font-family: AvenirDemi;
  font-size: 10px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.36)'};
  margin-bottom: 10px;
`

export const SectionLabel = styled.div`
  font-family: AvenirMedium;
  font-size: 9px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.36)'};
  margin-top: 8px;
  margin-bottom: 4px;

  &:first-child {
    margin-top: 0;
  }
`

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 4px 0;
  gap: 8px;
`

export const ChildRow = styled.a`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 4px 0;
  gap: 8px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.1s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.04);

    & > div:first-child {
      text-decoration: underline;
    }
  }
`

export const Name = styled.div`
  font-family: AvenirDemi;
  font-size: 13px;
  color: ${colors.textPrimary || 'rgba(0, 0, 0, 0.86)'};
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`

export const Role = styled.div`
  font-family: AvenirMedium;
  font-size: 11px;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.5)'};
  text-transform: lowercase;
  white-space: nowrap;
  flex-shrink: 0;
`

export const Star = styled.span`
  color: ${colors.ohOrange || 'rgba(242, 94, 53, 1)'};
  font-size: 12px;
`

export const AppDot = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) =>
    props.$hasApp
      ? '#10b981' // green
      : 'rgba(0, 0, 0, 0.18)'}; // muted dot when no app
  flex-shrink: 0;
  transition: transform 0.1s ease;

  &:hover {
    transform: scale(1.4);
  }
`

export const PopoverBody = styled.div`
  padding: 10px 12px;
  font-family: AvenirMedium;
  font-size: 12px;
  color: ${colors.textPrimary || 'rgba(0, 0, 0, 0.86)'};
  min-width: 180px;
  line-height: 1.6;
`

export const PopoverTitle = styled.div`
  font-family: AvenirDemi;
  font-size: 11px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.36)'};
  margin-bottom: 4px;
`

export const PopoverRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;

  & > span:first-child {
    color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.5)'};
  }
`

export const Empty = styled.div`
  font-family: AvenirMedium;
  font-size: 11px;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.36)'};
  font-style: italic;
`
